module.exports = __webpack_public_path__ + "static/media/mmsys_100.15c44f3c.ico";